(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-experience"] && !Shopify.designMode) return;
  try {
    
  const initCartCarousel = (root = document) => {
    root.querySelectorAll('[data-cart-carousel]').forEach((track) => {
      if (track.dataset.carouselReady === 'true') return;
      track.dataset.carouselReady = 'true';
      const section = track.closest('.cart-experience__products');
      const previous = section?.querySelector('[data-carousel-prev]');
      const next = section?.querySelector('[data-carousel-next]');
      const updateButtons = () => {
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * .9, 240), behavior: 'smooth' });
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    });
  };

  initCartCarousel();

  document.querySelectorAll('[data-cart-recommendations-url]').forEach((container) => {
    fetch(container.dataset.cartRecommendationsUrl)
      .then((response) => response.text())
      .then((text) => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = text;
        const updated = wrapper.querySelector('#' + container.id);
        if (updated && updated.innerHTML.trim()) {
          container.replaceWith(updated);
          initCartCarousel(document);
        }
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();
})();
